<template>
  <div>
    <div class="headCont">
      <div class="img">
        <img :src="$imgUrl + member.avatars" alt="" />
      </div>
      <div class="box">
        <div class="titleBox">
          <div class="name">{{ member.member_info.realname }}</div>
          <div class="star">
            <div
              class="iconfont icon-collection_fill"
              v-for="item in star"
            ></div>
          </div>
        </div>
        <div class="textBox">
          <div class="imgBox">
            <img src="../../assets/img/rz.png" alt="" />
          </div>
          <div class="text1">官方认证,服务保障</div>
        </div>
        <div class="textBox">
          <div class="text">
            综合服务分：{{ member.member_info.evaluatelength }}分
          </div>
          <div class="text">
            累计服务：{{ member.member_info.orderlength }}次
          </div>
        </div>
        <div class="lxBox">
          <div class="name">服务类型:</div>
          <div class="texts">
            <div class="txt" v-for="item in member.member_info.config_cn">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="xdBox" v-if="memberInfo.id != id">
        <div class="btn" @click="sxShow = true">立即下单</div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="contBox">
          <div class="headText">师傅信息</div>
          <div class="contList">
            <!-- <div class="contLi">
              <div class="name">联系方式:</div>
              <div class="txtBox">
                {{ member.member_info.ling_mobile }}
              </div>
            </div> -->
            <div class="contLi">
              <div class="name">个人介绍:</div>
              <div class="txtBox">
                {{ member.member_info.ling_content }}
              </div>
            </div>
            <div class="contLi">
              <div class="name">服务时间:</div>
              <div class="txtBox">{{ member.member_info.ling_time }}</div>
            </div>
            <div class="contLi">
              <div class="name">服务区域:</div>
              <div class="txtBox">
                {{ member.member_info.ling_district_cn }}
              </div>
            </div>
          </div>
        </div>
        <div class="contBox">
          <div class="headText">
            综合评分 <span>{{ member.member_info.evaluatelength }}</span
            >分
          </div>
          <div class="contList">
            <div class="pjList">
              <div class="pjLi" v-for="item in evaluateList">
                <div class="img">
                  <img :src="$imgUrl + item.avatars" alt="" />
                </div>
                <div class="pjLiBox">
                  <div class="pjHead">
                    <div class="nameBox">
                      <div class="name">{{ item.realname }}</div>
                    </div>
                    <div class="txt">
                      <div class="t">{{ item.time }} · {{ item.score }}分</div>
                    </div>
                  </div>
                  <div class="pjTxt">{{ item.content }}</div>
                  <div class="pjImgs">
                    <div
                      class="pjimg img"
                      v-for="(chi, zIn) in item.resources"
                      @click="reClick(item.resources, zIn)"
                    >
                      <img :src="$imgUrl + chi.path_name" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightCont">
        <div class="cont">
          <div class="contHead">
            <div class="name">零工资讯</div>
          </div>
          <div class="contList">
            <div class="li">提供全方位权益保障，专业保险保驾护航</div>
            <div class="li">提供全程交易担保，服务满意 才交付费用</div>
          </div>
        </div>
        <div class="cont" v-if="tjList">
          <div class="contHead">
            <div class="name">匠心师傅推荐</div>
          </div>
          <div class="renList">
            <div class="renLi" v-for="item in tjList">
              <div class="img">
                <img :src="$imgUrl + item.avatars" alt="" />
              </div>
              <div class="box">
                <div class="titleBox">
                  <div class="name">{{ item.realname }}</div>
                  <div class="star">
                    <div
                      class="iconfont icon-collection_fill"
                      v-if="item.evaluatelength >= 20"
                    ></div>
                    <div
                      class="iconfont icon-collection_fill"
                      v-if="item.evaluatelength >= 40"
                    ></div>
                    <div
                      class="iconfont icon-collection_fill"
                      v-if="item.evaluatelength >= 60"
                    ></div>
                    <div
                      class="iconfont icon-collection_fill"
                      v-if="item.evaluatelength >= 80"
                    ></div>
                    <div
                      class="iconfont icon-collection_fill"
                      v-if="item.evaluatelength >= 90"
                    ></div>
                  </div>
                </div>
                <div class="textBox">
                  <div class="text c-1">服务类型：{{ item.config_cn }}</div>
                  <div class="text">累计服务：{{ item.orderlength }}次</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LgXd :id="id" v-if="sxShow" @show="sxShowjs" />
    <ImgBig
      @del="imgDelClick"
      :list="imgList"
      :index="imgIndex"
      v-if="imgShow"
    />
  </div>
</template>

<script>
import ImgBig from "../component/imgBig.vue";
import LgXd from "../component/lgXd.vue";

export default {
  components: {
    LgXd,
    ImgBig,
  },
  name: "",
  data() {
    return {
      imgShow: false,
      imgIndex: 0,
      imgList: [],
      id: 0,
      sxShow: false,
      member: {
        member_info: {},
      },
      memberInfo: {},
      evaluateList: [],
      tjList: [],
      star: 0,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.get();
    this.infoget();
    this.odd_evaluate_get();
  },
  methods: {
    reClick(imgs, i) {
      this.imgIndex = i;
      this.imgShow = true;
      this.imgList = imgs;
    },
    imgDelClick() {
      this.imgShow = false;
    },
    odd_evaluate_get() {
      this.$get("/nozzle/web/odd_evaluate_gets", {
        id: this.id,
      }).then((res) => {
        console.log(res.list);
        if (res.list) {
          for (let i = 0; i < res.list.length; i++) {
            const e = res.list[i];
            e.time = this.timeago(e.create_time);
          }
          this.evaluateList = res.list;
        }
      });
    },
    infoget() {
      this.$get("/nozzle/web/member_info").then((res) => {
        console.log(res);
        this.memberInfo = res.member;
      });
    },
    messageClick() {
      this.$post("/chat/chat_begin", {
        id: this.id,
        user_type: 1,
      }).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          this.$router.push({
            path: "/message",
            query: {
              id: this.id,
              lgType: 1,
            },
          });
          // window.open("#/message?id=" + this.id + "&lgType=" + 1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    timeago(dateTimeStamp) {
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let week = day * 7;
      let month = day * 30;
      let time1 = new Date().getTime(); //当前的时间戳
      dateTimeStamp = this.$moment(dateTimeStamp * 1000).format();
      dateTimeStamp = this.$moment(dateTimeStamp).format("YYYY/M/D HH:mm");
      let time2 = Date.parse(new Date(dateTimeStamp)); //指定时间的时间戳
      let time = time1 - time2;
      let result = null;
      if (time < 0) {
        result = "--";
      } else if (time / month >= 1) {
        result = parseInt(time / month) + "月前";
      } else if (time / week >= 1) {
        result = parseInt(time / week) + "周前";
      } else if (time / day >= 1) {
        result = parseInt(time / day) + "天前";
      } else if (time / hour >= 1) {
        result = parseInt(time / hour) + "小时前";
      } else if (time / minute >= 1) {
        result = parseInt(time / minute) + "分钟前";
      } else {
        result = "刚刚";
      }
      return result;
    },
    sxShowjs() {
      this.sxShow = false;
    },
    get() {
      this.$get("/nozzle/web/member_odd_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        if (res.member) {
          if (res.member.member_info.config_cn) {
            res.member.member_info.config_cn =
              res.member.member_info.config_cn.split(",");
          }
          this.star = Math.floor(res.member.member_info.evaluatelength / 20);
          this.member = res.member;
        }
        this.tjList = res.list;
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headCont {
  width: 1280px;
  margin: auto;
  background-color: #fff;
  border-radius: 10px;
  padding: 25px;
  display: flex;
  margin-top: 15px;
  .img {
    width: 80px;
    height: 80px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .box {
    width: calc(100% - 380px);
    padding-left: 15px;
    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .name {
        font-weight: 600;
        font-size: 20px;
        margin-right: 10px;
      }
      .star {
        display: flex;
        align-items: center;
        .iconfont {
          color: #ee0707;
          font-size: 20px;
          margin-right: 2px;
        }
      }
    }
    .textBox {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .imgBox {
        width: 22px;
        margin-right: 5px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text1 {
        color: #f10e0e;
        margin-right: 25px;
      }
      .text {
        color: #666;
        margin-right: 25px;
      }
    }
    .lxBox {
      display: flex;
      .name {
        color: #666;
        width: 70px;
        margin-top: 4px;
      }
      .texts {
        width: calc(100% - 70px);
        display: flex;
        flex-wrap: wrap;
        .txt {
          padding: 3px 10px;
          border-radius: 5px;
          border: 1px solid #1677ff;
          color: #1677ff;
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .xdBox {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      background-color: #ee0707;
      color: #fff;
      border-radius: 5px;
      width: 100px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 15px;
    }
  }
}
.content {
  width: 1280px;
  padding-top: 20px;
  margin: auto;
  display: flex;
  .leftCont {
    width: calc(100% - 360px);
    .headText {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 15px;
      span {
        font-weight: 900;
        color: #ee0707;
        font-size: 24px;
        margin-right: 2px;
      }
    }
    .contBox {
      background-color: #fff;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 15px;
      .contList {
        .contLi {
          display: flex;
          margin-bottom: 15px;
          .name {
            color: #666;
            width: 80px;
          }
          .text {
            width: calc(100% - 80px);
          }
        }
        .contLi:last-child {
          margin-bottom: 0;
        }
      }
      .pjList {
        box-sizing: border-box;
        width: calc(100% - 0px);
        .pjLi {
          display: flex;
          margin-bottom: 15px;
          .img {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              object-fit: cover;
            }
          }
          .pjLiBox {
            width: calc(100% - 60px);
            margin-left: 15px;
            box-sizing: border-box;
            border-bottom: 1px solid #ebebeb;
            .pjHead {
              height: 45px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              .nameBox {
                color: #11192d;
                display: flex;
                align-items: center;
                // .name{}
              }
              .txt {
                color: #7c889c;
                display: flex;
                align-items: center;
                .d {
                  margin: 0 5px;
                }
                .star {
                  margin-top: 1px;
                  display: flex;
                  .iconfont {
                    color: #e70303;
                  }
                }
              }
            }
            .pjTxt {
              margin-bottom: 10px;
              margin-top: 5px;
            }
            .pjImgs {
              overflow: hidden;
              .pjimg {
                float: left;
                width: calc(20% - 8px);
                margin-right: 10px;
                margin-bottom: 10px;
                padding-top: calc(20% - 8px);
                position: relative;
                cursor: pointer;
                img {
                  position: absolute;
                  top: 0;
                  left: 0;
                  border-radius: 5px;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
              .pjimg:nth-child(5n) {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
  .rightCont {
    width: 360px;
    padding-left: 20px;
    .cont {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 10px;
      .contHead {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;
        .name {
          font-weight: 600;
        }
        .iconfont {
          font-size: 14px;
          color: #9c9c9c;
        }
      }
      .contList {
        padding: 15px;
        .li {
          padding-bottom: 15px;
        }
        .li:last-child {
          padding-bottom: 0;
        }
      }
      .renList {
        .renLi {
          display: flex;
          padding: 15px;
          padding-bottom: 0;
          .img {
            width: 80px;
            height: 80px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              object-fit: cover;
            }
          }
          .box {
            width: calc(100% - 80px);
            padding-left: 15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .titleBox {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              .name {
                font-weight: 600;
                font-size: 15px;
                margin-right: 10px;
              }
              .star {
                display: flex;
                align-items: center;
                .iconfont {
                  color: #ee0707;
                  margin-right: 2px;
                }
              }
            }
            .textBox {
              .text {
                font-size: 13px;
                color: #666;
                margin-top: 5px;
              }
            }
          }
        }
        .renLi:last-child {
          padding-bottom: 15px;
        }
      }
    }
  }
}
</style>
